// export this package's api
import Upload from './Upload';

export default Upload;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-upload/src/index.js
// module id = 917
// module chunks = 0